module.exports = __webpack_public_path__ + "static/media/fontello.014bfb28.svg";


//////////////////
// WEBPACK FOOTER
// ./src/font/fontello.svg?8095705
// module id = 334
// module chunks = 0